import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { useGetAward } from "../../../hooks/Award/useGetAward"
import { AwardEntity } from "../../../Objects/Awards/AwardEntity"
import { awardMemory } from "../../../Objects/Memory/Memory"
import { AwardPupop } from "./AwardPupop"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useTranslation } from "react-i18next"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const AwardsPage: React.FC = () => {
  const { t } = useTranslation("list")

  const [enableAwards, setEnableAwards] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const { handleGetAward } = useGetAward()

  const [award, setAward] = useState<AwardEntity | undefined>(undefined)

  useEffect(() => {
    handleGetAward(() => {})
  }, [])

  const handleOpenEdite = (id: number) => {
    const award = awardMemory.findById(id)

    handleSwitchEditeOrAdd(true, award)
  }

  const handleSwitchEditeOrAdd = (status: boolean, selectedAward?: AwardEntity) => {
    setAward(selectedAward)

    setEnableAwards(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  const handleCopyAward = () => {
    if (!award) {
      return
    }

    setAward(new AwardEntity({ ...award, id: -1 }))
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("label_awards_page_message_count")}
          messageEmpty={t("label_awards_page_message_empty")}
          nameFindSearch={t("label_awards_page_place_holder")}
          data={awardMemory.getListCards(true)}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetAward(() => {})}
          handleOnClick={(e) => handleOpenEdite(e)}
        />
      </div>

      {enableAwards && (
        <AwardPupop
          award={award}
          title={award && award.id !== -1 ? t("awards:title_popup_edite") : t("awards:title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyAward}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="premiacoes"
          title={t("dataImport:title", { target: t("dataImport:target_awards") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetAward(() => {})}
        />
      )}
    </>
  )
}
